export class AnalyzeSqlQueryRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sqlQueryExecutionIds",
            "baseName": "sqlQueryExecutionIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return AnalyzeSqlQueryRequest.attributeTypeMap;
    }
    constructor() {
    }
}
